import { GridWrapper } from "@insite/mobius/GridContainer";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { PageStyle } from "@insite/mobius/Page";
import getColor from "@insite/mobius/utilities/getColor";
import { PageLayoutWrapper } from "@store/Overrides/PageLayout";
import { clearfixStyles, lazyLoadKeyframes } from "@store/theme/common/mixins";
import { css } from "styled-components";

export default {
    css: css`
        html {
            overflow-x: hidden;
        }

        #react-app {
            > div:first-child {
                min-height: 100vh;
                display: flex;
                flex-direction: column;
                width: 100%;
                height: 100%;

                > ${PageLayoutWrapper} {
                    > ${PageStyle} {
                        overflow: inherit;
                    }
                }

                footer {
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                    justify-content: flex-end;
                }
            }
        }

        ${GridWrapper} {
            ${clearfixStyles()}
            max-width: none;
        }

        ${GridItemStyle} {
            overflow-wrap: normal;
            word-wrap: normal;
            -ms-word-break: normal;
            word-break: normal;
        }

        ${lazyLoadKeyframes()}

        /* -- Form ------------------------------------------------------------ */

        input,
        textarea {
            &::placeholder {
                color: ${getColor("placeholder")};
                opacity: 1;
            }

            &:disabled,
            &.disabled {
                &::placeholder {
                    color: ${getColor("placeholder.disabled")};
                }
            }
        }

        fieldset {
            width: 100%;
            padding: 0;
            margin: 0;
            border: 0;
        }

        /* stylelint-disable property-no-vendor-prefix */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        input[type="number"] {
            -moz-appearance: textfield !important;
        }
        /* stylelint-enable property-no-vendor-prefix */

        input:placeholder-shown::-webkit-search-cancel-button {
            display: none;
        }

        input:not(:placeholder-shown)::-webkit-search-cancel-button {
            padding: 1px;
            margin: 0 14px;
            cursor: pointer;
        }
    `,
};
